module.exports = __webpack_public_path__ + "img/fr-flag.75dbc641.png";